


































































import { CheckIsDevelop, CheckIsMUZE } from "@/helper/shareHelper";
import { ApplipcationStoreType, Package } from "@/enums/enums";
import { CheckMerchantAFPPackage, CheckMerchantPackage, MerchantId } from "@/helper/userHelper";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { GetFileServiceUrl } from "@/helper/uploadHelper";
import ModalLinePEAKConnect from "./ModalLinePEAKConnect.vue";
const IsMUZE = CheckIsMUZE();

const StoreLogIn = namespace("LogIn");

@Component({ components: { ModalLinePEAKConnect } })
export default class ApplicationStore extends Vue {
  private isShowApplicationStore = false;
  private PeakPeakengineURL = process.env.VUE_APP_PeakEngine;
  private PeakAccountURL = process.env.VUE_APP_PeakAccount;
  private showModalLinePEAKConnect = false;
  private GetFileServiceUrl = GetFileServiceUrl;
  private isDevelop = CheckIsDevelop();
  private showDueDatePeakBoard = false;
  private isMUZE = IsMUZE;
  private isFreeTrialPackage = CheckMerchantPackage([Package.Trial]);
  private isMerchantPackageAFP = CheckMerchantAFPPackage();

  get isCanUsePeakBoard() {
    return this.$can("access", "PeakBoard") && !this.isMerchantPackageAFP;
  }
  get isCanUsePeakTax() {
    return this.$can("access", "PeakTax");
  }
  get isCanUsePeakAsset() {
    return this.$can("access", "PeakAsset");
  }
  get isCanUsePeakPayroll() {
    return !this.isMerchantPackageAFP;
  }
  @StoreLogIn.Action
  private DoRedirectByApplipcationStore!: (applipcationStoreType: ApplipcationStoreType) => void;

  public Hide() {
    this.isShowApplicationStore = false;
  }
  public RedirectToPeak() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Peak);
  }
  public RedirectToNewPeak() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.NewPeak);
  }
  public RedirectToPeakPayroll() {
    this.$router.push({
      name: "home",
      query: { emi: MerchantId().PeakEncryption() },
    });
    this.Hide();
  }
  public RedirectToPeakBoard() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Board);
  }
  public RedirectToPeakAsset() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Asset);
  }
  public RedirectToPeakTax() {
    this.Hide();
    this.DoRedirectByApplipcationStore(ApplipcationStoreType.Tax);
  }
  public DoShowModalLinePEAKConnect() {
    this.showModalLinePEAKConnect = true;
    this.Hide();
  }
  public RedirectToUpgrade() {
    window.open(`${process.env.VUE_APP_PeakAccount}setting/billing?emi=${MerchantId().PeakEncryption()}`);
  }
}
